import { render, staticRenderFns } from "./CustomsInvoicesPage.vue?vue&type=template&id=2ecc3136&scoped=true&"
import script from "./CustomsInvoicesPage.vue?vue&type=script&lang=ts&"
export * from "./CustomsInvoicesPage.vue?vue&type=script&lang=ts&"
import style0 from "./CustomsInvoicesPage.vue?vue&type=style&index=0&id=2ecc3136&scoped=true&lang=css&"
import style1 from "./CustomsInvoicesPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc3136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VCombobox,VIcon,VRow,VSheet,VSwitch,VTooltip})
